<p-table [value]="jsonData" [tableStyle]="{ 'min-width': '50rem' }" class="dark-theme">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of columns">{{col.header}}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td *ngFor="let col of columns" [innerHTML]="rowData[col.field]"></td>
      </tr>
    </ng-template>
  </p-table>